import React from 'react';

import { link } from '@aline/routes';
import { Typography } from '@mui/material';
import type { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-premium';
import { Link } from 'react-router-dom';
import { Apollo } from 'src/gql/generated';
import { openLinkFromAnchorClick } from 'src/helpers';
import { alineLinkButtonStylesWithUnderlineNotBold } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  cell: {
    alignItems: 'center',
    display: 'flex',
    // Needed for ellipse to work on noWrap text.
    width: '100%',
  },
  iconButton: {
    marginLeft: theme.spacing(1),
  },
  nameLink: {
    minWidth: 0,
    overflow: 'hidden',
    textDecoration: 'none',
  },
  text: {
    ...alineLinkButtonStylesWithUnderlineNotBold,
  },
}));

export type WorkflowCellWorkflow = Pick<
  Apollo.Workflow,
  'id' | 'name' | '__typename' | 'variant'
> | null;

export function WorkflowCell<T extends GridValidRowModel>({
  value: workflow,
}: GridRenderCellParams<T, WorkflowCellWorkflow>): JSX.Element {
  const { classes } = useStyles();

  if (!workflow) return <>-</>;

  const isTemplate = workflow.variant === Apollo.WorkflowVariant.Template;
  const workflowHref = isTemplate
    ? link.TemplateSelectedTemplateIndex({ workflowId: String(workflow.id) })
    : link.WorkflowDetail({ workflowId: String(workflow.id) });
  const title = workflow.name || 'Untitled Workflow';

  return (
    <div className={classes.cell}>
      <Link
        className={classes.nameLink}
        to={workflowHref}
        onClick={e => openLinkFromAnchorClick(e, workflowHref, { title })}
      >
        <Typography noWrap className={classes.text}>
          {title}
        </Typography>
      </Link>
    </div>
  );
}
